import * as React from 'react';
import {
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaLock,
  FaPercent,
} from 'react-icons/fa';

import { CardTitle } from '~common/UI';
import { Popup } from '~common/components/Popup';

export function StakingTitleWithHelp() {
  return (
    <div className="flex mb-3">
      <h3 className="mb-0 text-gray-100">
        <FaCoins className="inline-block mr-1 text-2xl" />{' '}
        <span className="">Stake TPAD for IDO / other sale participation</span>
      </h3>
      <div className="ml-2 mt-1">
        <Popup
          header="How does TPAD staking work?"
          className="w-[800px] left-[-200px]">
          <p>
            To participate in IDOs or other sales you need to stake TPAD in one
            of the staking pools below to be eligible to participate in the
            sales.
          </p>
          <p>
            We offer nine staking pools (14, 30, 60, 90, 180, 365, 730 and
            1095-day) with different staking periods. The longest-term pools,
            365, 730 and 1095 are also eligible for special perks and the
            1095-day pool will always have the highest perks and benefits (such
            as higher allocations, airdrops from incubated projects, APY
            rewards).
          </p>
          <p>There are a few important characteristics to note:</p>
          <ul className="space-y-2">
            <li>
              <FaCalculator className="inline-block mr-2" />{' '}
              <b>Allocation Boosters</b> – Every long-term staking pool has a
              multiplier that will give you an extra allocation according to
              your staking duration and Echelon (Guaranteed - G, All-Access
              Guaranteed - AAG or Super All-Access Guaranteed - SAAG). If you
              stake so that your allocation booster is +390% i.e. 4.9x and your
              level is Associate - 15x, then your effective multiplier is 15 x
              4.9 = 73.5x. Then if the base allocation in an IDO is $15, then
              the amount you are able to purchase is 73.5 x $15 = $1102.50.
            </li>
            <li>
              <FaChartLine className="inline-block mr-2" /> <b>APR</b> - The
              level of interest we pay for staking.
            </li>
            <li>
              <FaLock className="inline-block mr-2" />{' '}
              <b>Lock duration/maturity</b> – Lock duration/maturity - For how
              long you are unable to unstake your TPAD without a penalty, early
              withdrawal fee.
            </li>
            <li>
              <FaPercent className="inline-block mr-2" />{' '}
              <b>Early withdrawal fee</b> - How much TPAD you will donate to
              Treasury by unstaking from an immatured staking.
            </li>
          </ul>

          <p>
            Every pool will give you an allocation, but the highest allocation
            is the only one that is valid for the allocations. Once you stake
            enough, you are free to register for as many IDOs as you want.
          </p>
        </Popup>
      </div>
    </div>
  );
}
